import { RouteObject } from 'react-router-dom';

import { LOGIN_ROUTES } from './login.constants';

export const loginRoutes = [
  {
    path: LOGIN_ROUTES.LOGIN,
    lazy: async () => ({
      Component: (await import('./LoginPage')).LoginPage,
    }),
  },

  {
    path: LOGIN_ROUTES.FTN_AUTH,
    lazy: async () => ({
      Component: (await import('./SignupFTNAuthenticationPage'))
        .SignupFTNAuthenticationPage,
    }),
  },
  {
    path: LOGIN_ROUTES.SIGNUP,
    lazy: async () => ({
      Component: (await import('./SignupFTNAuthenticationPage'))
        .SignupFTNAuthenticationPage,
    }),
  },

  {
    path: LOGIN_ROUTES.CREATE_ACCOUNT,
    lazy: async () => ({
      Component: (await import('./CreateAccountPage')).CreateAccountPage,
    }),
  },
  {
    path: LOGIN_ROUTES.QUICK_SIGNUP,
    lazy: async () => ({
      Component: (await import('./CreateAccountPage')).CreateAccountPage,
    }),
  },

  {
    path: LOGIN_ROUTES.COMPLETE_REGISTRATION,
    lazy: async () => ({
      Component: (await import('./CompleteRegistrationPage'))
        .CompleteRegistrationPage,
    }),
  },

  {
    path: LOGIN_ROUTES.FORGOT_PASSWORD,
    lazy: async () => ({
      Component: (await import('./ForgotPasswordPage')).ForgotPasswordPage,
    }),
  },

  {
    path: LOGIN_ROUTES.RESET_PASSWORD,
    lazy: async () => ({
      Component: (await import('./ResetPasswordPage')).ResetPasswordPage,
    }),
  },

  {
    path: LOGIN_ROUTES.LOGOUT,
    lazy: async () => ({
      Component: (await import('@views/LogoutPage')).LogoutPage,
    }),
  },
] satisfies RouteObject[];
